module.exports = __webpack_public_path__ + "img/ad19a8a.jpg";